import React, { useState, useContext } from 'react';
import { motion } from 'framer-motion';
import { UserContext } from '../../../context/UserContext';
import { SystemError } from '../../error/SystemError';
import { dismissModal } from '../../../service/modal-service';
import { deleteAlbum } from '../../../api/post/buzz-api';
import { LoadingCover } from '../../commons/LoadingCover';
import BottomSheet from '../../commons/BottomSheet';
import { Trash2, AlertTriangle, FolderX } from 'lucide-react';

export const AlbumDelete = (props) => {
    const getAlbums = props.getAlbums
    const editAlbumName = props.editAlbumName

    const [isOpen, setIsOpen] = useState(true)
    const [isLoading, setIsLoading] = useState(false)
    const [isSystemError, setIsSystemError] = useState(false)
    const [errorContent, setErrorContent] = useState({'header': "", 'body': ""})
    
    const { userId } = useContext(UserContext)

    const handleClose = () => {
        dismissModal()
    }

    const removeAlbum = async() => {
        setIsLoading(true)
        try {
            await deleteAlbum(userId, editAlbumName)
            setIsLoading(false)
            getAlbums()
            dismissModal()
        } catch (error) {
            console.log(error)
            setErrorContent({'header': "Error deleting album", 'body': "Please try again. If problem persists, contact us at support@stringssg.com"})
            setIsSystemError(true)
            setIsLoading(false)
        }
    }

    return (
        <>
            <BottomSheet isOpen={isOpen} onClose={handleClose} maxWidth="md">
                <BottomSheet.Header>
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center">
                            <FolderX className="w-5 h-5 text-red-600" />
                        </div>
                        <div>
                            <BottomSheet.Title>Delete Album</BottomSheet.Title>
                            <p className="text-xs text-gray-500">{editAlbumName}</p>
                        </div>
                    </div>
                </BottomSheet.Header>

                <BottomSheet.Content>
                    <div className="flex items-start gap-3 p-4 bg-red-50 rounded-xl border border-red-100">
                        <AlertTriangle className="w-5 h-5 text-red-500 shrink-0 mt-0.5" />
                        <div>
                            <p className="text-sm font-medium text-red-800">This action cannot be undone</p>
                            <p className="text-sm text-red-600 mt-1">
                                All photos in this album will be permanently deleted.
                            </p>
                        </div>
                    </div>
                </BottomSheet.Content>

                <BottomSheet.Footer>
                    <div className="flex gap-3">
                        <BottomSheet.CloseButton>Cancel</BottomSheet.CloseButton>
                        <motion.button 
                            whileTap={{ scale: 0.98 }}
                            type="button" 
                            className="flex-1 px-4 py-3 rounded-xl font-semibold text-white bg-linear-to-r from-red-600 to-red-500 shadow-lg shadow-red-200 disabled:opacity-50 flex items-center justify-center gap-2" 
                            disabled={isLoading}
                            onClick={removeAlbum}
                        >
                            <Trash2 className="w-4 h-4" />
                            {isLoading ? 'Deleting...' : 'Delete Album'}
                        </motion.button>
                    </div>
                </BottomSheet.Footer>
            </BottomSheet>

            {isLoading && <LoadingCover />}
            {isSystemError && <SystemError errorContent={errorContent} setIsSystemError={setIsSystemError} />}
        </>
    )
}
